"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformStyleguideToJSON = exports.transformJSONToStyleguide = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

var _entityReference = require("./entity-reference");

var _organizationSummary = require("./organization-summary");

var _remPreferences = require("./rem-preferences");

var _styleguideStatusEnum = require("./styleguide-status-enum");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformStyleguideToJSON = function transformStyleguideToJSON(value) {
  return {
    id: value.id,
    name: value.name,
    description: value.description,
    platform: value.platform,
    thumbnail: value.thumbnail,
    status: (0, _styleguideStatusEnum.transformStyleguideStatusEnumToJSON)(value.status),
    organization: value.organization && (0, _organizationSummary.transformOrganizationSummaryToJSON)(value.organization),
    rem_preferences: value.remPreferences && (0, _remPreferences.transformRemPreferencesToJSON)(value.remPreferences),
    created: value.created,
    updated: value.updated,
    number_of_members: value.numberOfMembers,
    number_of_connected_components: value.numberOfConnectedComponents,
    number_of_components: value.numberOfComponents,
    number_of_text_styles: value.numberOfTextStyles,
    number_of_colors: value.numberOfColors,
    number_of_spacing_tokens: value.numberOfSpacingTokens,
    parent: value.parent && (0, _entityReference.transformEntityReferenceToJSON)(value.parent)
  };
};

exports.transformStyleguideToJSON = transformStyleguideToJSON;

var transformJSONToStyleguide = function transformJSONToStyleguide(value) {
  return {
    id: value.id,
    name: value.name,
    description: value.description,
    platform: value.platform,
    thumbnail: value.thumbnail,
    status: (0, _styleguideStatusEnum.transformJSONToStyleguideStatusEnum)(value.status),
    organization: value.organization && (0, _organizationSummary.transformJSONToOrganizationSummary)(value.organization),
    remPreferences: value.rem_preferences && (0, _remPreferences.transformJSONToRemPreferences)(value.rem_preferences),
    created: value.created,
    updated: value.updated,
    numberOfMembers: value.number_of_members,
    numberOfConnectedComponents: value.number_of_connected_components,
    numberOfComponents: value.number_of_components,
    numberOfTextStyles: value.number_of_text_styles,
    numberOfColors: value.number_of_colors,
    numberOfSpacingTokens: value.number_of_spacing_tokens,
    parent: value.parent && (0, _entityReference.transformJSONToEntityReference)(value.parent)
  };
};
/**
 * 
 * @export
 * @interface Styleguide
 */


exports.transformJSONToStyleguide = transformJSONToStyleguide;